import ApiService from "../ApiService";

const ProviderService = {
    getProviders() {
        return ApiService.customRequest({
            url: `${ApiService.farmadomiciliosApiURL}/provider`
        })
    }
};

export default ProviderService;
